import { Box } from '@mui/material';

interface UfoIconProps {
  width?: number;
}

export function UfoIcon({ width = 78 }: UfoIconProps) {
  return (
    <Box
      component="img"
      src="/assets/ufoIcon.png"
      alt="ufo-icon"
      width={width}
    />
  );
}
